import React from 'react';
import {View} from 'react-native';
import {get} from 'lodash';

import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {REPORT_CLOSE_TO_EXECUTIVE_DIRECTOR_RANK} from '/enum/records.enum';
import {withTranslation} from '/provider/TranslationProvider';

import CloseToRankReportContent from '../CloseToRankReportContent';

import {styles} from './CloseToExecutiveDirectorReportContent.style';

interface RankProgression {
  [key: string]: any;
}

interface RecordData {
  __extras: {
    rankProgression: RankProgression;
  };
}

interface CloseToExecutiveDirectorReportContentProps {
  tt: (key: string, defaultText?: string) => string;
  recordData: RecordData;
}

const CloseToExecutiveDirectorReportContent: React.FC<
  CloseToExecutiveDirectorReportContentProps
> = ({tt, recordData = {__extras: {rankProgression: {}}}}) => {
  const rankProgression = get(recordData, '__extras.rankProgression', {});

  return (
    <View>
      <View style={styles.header}>
        <Gutter>
          <Text variant="heading">
            {tt('title', 'Close To Executive Director')}
          </Text>
        </Gutter>
      </View>
      <CloseToRankReportContent
        progressionData={rankProgression}
        report={REPORT_CLOSE_TO_EXECUTIVE_DIRECTOR_RANK}
      />
    </View>
  );
};

export default withTranslation('reportCardContent.closeToExecutiveDirector')(
  CloseToExecutiveDirectorReportContent,
);
